var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { v4 as uuidv4 } from 'uuid';
import { getCurrentScene, setCurves, setPressingMode } from "../../../redux/actions/canvas/canvas";
import store from "../../../redux/store";
// Время в миллисекундах, через которое линия лазерной указки полностью исчезнет
var LASER_FADE_DURATION = 1200; // 1.2 секунды
// Интервал обновления для постепенного исчезновения
var FADE_INTERVAL = 10; // миллисекунды между удалением точек
// Храним таймеры для каждой линии
var laserTimers = new Map();
export var start = function (event) {
    setPressingMode(true);
    var scene = getCurrentScene();
    var _a = store.getState().canvas, cameraOffset = _a.cameraOffset, scale = _a.scale;
    if (scene) {
        var curves = scene.curves;
        var pos = event.target.getStage().getPointerPosition();
        var adjustedPos = {
            x: (pos.x - cameraOffset.x) / scale,
            y: (pos.y - cameraOffset.y) / scale
        };
        var id = uuidv4();
        // Создаем линию с фиксированными параметрами для лазерной указки
        var laserCurve = {
            id: id,
            tool: 'curve',
            points: [adjustedPos.x, adjustedPos.y],
            attr: {
                stroke: '#FF0000',
                strokeWidth: 6 // Увеличенная толщина для лучшей видимости
            },
            time: new Date(),
            isLaserPointer: true // Флаг для идентификации линий лазерной указки
        };
        setCurves(__spreadArray(__spreadArray([], __read(curves), false), [laserCurve], false));
        // Не добавляем в историю откатов, так как линия временная и исчезает сама
    }
};
export var move = function (event) {
    var _a = store.getState().canvas, isPressed = _a.isPressed, cameraOffset = _a.cameraOffset, scale = _a.scale;
    var scene = getCurrentScene();
    if (!isPressed)
        return;
    if (scene) {
        var curves = scene.curves;
        var stage = event.target.getStage();
        var point = stage.getPointerPosition();
        // Adjust the point position considering the current camera offset and scale
        var adjustedPoint = {
            x: (point.x - cameraOffset.x) / scale,
            y: (point.y - cameraOffset.y) / scale
        };
        var lastCurve = curves[curves.length - 1];
        // Проверяем, что последняя кривая - это именно наша лазерная указка
        if (lastCurve && lastCurve.isLaserPointer) {
            // Сглаживание: добавляем точку только если она достаточно далеко от предыдущей
            var points = lastCurve.points;
            var lastX = points[points.length - 2];
            var lastY = points[points.length - 1];
            var minDistance = 2 / scale; // минимальная дистанция с учетом масштаба
            var distance = Math.sqrt(Math.pow(adjustedPoint.x - lastX, 2) +
                Math.pow(adjustedPoint.y - lastY, 2));
            // Добавляем точку только если она достаточно далеко
            if (distance > minDistance) {
                lastCurve.points = lastCurve.points.concat([adjustedPoint.x, adjustedPoint.y]);
                // replace last
                curves.splice(curves.length - 1, 1, lastCurve);
                setCurves(curves.concat());
            }
        }
    }
};
export var finish = function (event) {
    setPressingMode(false);
    var scene = getCurrentScene();
    if (scene && scene.curves.length > 0) {
        var lastCurve = scene.curves[scene.curves.length - 1];
        // Проверяем что это наша лазерная указка
        if (lastCurve && lastCurve.isLaserPointer) {
            var curveId = lastCurve.id;
            // Запускаем постепенное исчезновение линии
            startGradualFade(curveId);
        }
    }
};
// Функция для постепенного исчезновения линии
var startGradualFade = function (curveId) {
    // Очищаем предыдущий таймер если он существует
    if (laserTimers.has(curveId)) {
        clearInterval(laserTimers.get(curveId));
        laserTimers.delete(curveId);
    }
    // Вычисляем сколько точек нужно удалять за один интервал
    // чтобы линия исчезла за LASER_FADE_DURATION миллисекунд
    var intervalsCount = LASER_FADE_DURATION / FADE_INTERVAL;
    var fadeInterval = setInterval(function () {
        var currentScene = getCurrentScene();
        if (!currentScene) {
            clearInterval(fadeInterval);
            laserTimers.delete(curveId);
            return;
        }
        var curveIndex = currentScene.curves.findIndex(function (c) { return c.id === curveId; });
        if (curveIndex === -1) {
            // Линия уже удалена
            clearInterval(fadeInterval);
            laserTimers.delete(curveId);
            return;
        }
        var curve = currentScene.curves[curveIndex];
        // Вычисляем сколько точек удалить за этот интервал
        var totalPoints = curve.points.length / 2; // делим на 2, так как каждая точка это x,y
        var pointsToRemovePerInterval = Math.max(2, Math.ceil(totalPoints / intervalsCount));
        // Удаляем точки с начала (умножаем на 2, так как каждая точка это пара x,y)
        var newPoints = curve.points.slice(pointsToRemovePerInterval * 2);
        if (newPoints.length <= 2) {
            // Если осталось 2 или меньше точек, удаляем всю линию
            var updatedCurves = currentScene.curves.filter(function (c) { return c.id !== curveId; });
            setCurves(updatedCurves);
            clearInterval(fadeInterval);
            laserTimers.delete(curveId);
        }
        else {
            // Обновляем линию с новыми точками
            var updatedCurve = __assign(__assign({}, curve), { points: newPoints });
            var updatedCurves = __spreadArray([], __read(currentScene.curves), false);
            updatedCurves[curveIndex] = updatedCurve;
            setCurves(updatedCurves);
        }
    }, FADE_INTERVAL);
    // Сохраняем ссылку на таймер
    laserTimers.set(curveId, fadeInterval);
};
